module.exports = __webpack_public_path__ + "img/file1.62520800.png";